import {Box, Typography} from '@mui/material';
import {PropsWithChildren, ReactNode} from 'react';

type Props = PropsWithChildren<{
    title: ReactNode;
}>;

export default function NotFound({title, children}: Props) {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                minHeight: '90vh',
                gap: 5,
            }}
        >
            <Typography variant={'h1'}>{title}</Typography>
            <div>{children}</div>
        </Box>
    );
}
